export const API_CONFIG_SERVICE = "/api/config-service"
export const API_CONFIG_SERVICE_KEYVALUE = API_CONFIG_SERVICE + "/keyvalue"
export const API_CONFIG_SERVICE_GROUPS = API_CONFIG_SERVICE + "/groups"



// WEBPACK FOOTER //
// ./src/ConfigService/urls.js